import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import CurrentLightTheme from 'foundations-theming/themes/current/light/theme';
import { GlobalStyles } from './GlobalStyles';
import { ToastProvider } from '../Toast/ToastContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const shouldRenderToastProvider = () => {
  // If inside an iframe and the iframe is not a Storybook iframe, don't render the ToastProvider
  if (window !== window.top) {
    try {
      const isStorybookIframe = window.parent.document.querySelector('iframe[data-is-storybook="true"]');
      return isStorybookIframe !== null;
    } catch (error) {
      // Default to false in case of security restrictions
      return false;
    }
  }

  // Default to rendering the ToastProvider when not in an iframe
  return true;
};
export const AppProvider = ({
  // themeName = 'current',
  // themeMode = 'light',
  applyGlobalStyles = false,
  children,
  toast = {
    autoClose: true
  }
}) => {
  // In a follow-up PR, we can add support to load themes dynamically instead.
  // E.g. https://git.hubteam.com/errodriguez/hds-components-prototypes/blob/master/src/theming-experiment/ExperimentalAppProvider.tsx#L37-L46

  return /*#__PURE__*/_jsxs(StyledComponentsThemeProvider, {
    theme: CurrentLightTheme,
    children: [applyGlobalStyles ? /*#__PURE__*/_jsx(GlobalStyles, {}) : null, shouldRenderToastProvider() ? /*#__PURE__*/_jsx(ToastProvider, Object.assign({}, toast, {
      children: children
    })) : children]
  });
};